export default __webpack_public_path__ + "static/media/viber.b9d28971.png";